/**
 * Utility function for exporting data to CSV with proper UTF-8 encoding
 * Supports Arabic text and maintains Excel compatibility
 */

export const exportToCSV = (filename, headers, rows) => {
  /**
   * Export data to CSV file with BOM for Excel compatibility
   * @param {string} filename - Name of the file to download
   * @param {array} headers - Array of header titles
   * @param {array} rows - Array of row arrays
   */
  
  // Escape and wrap headers in quotes for CSV format
  const escapedHeaders = headers.map(h => `"${String(h).replace(/"/g, '""')}"`);
  
  // Escape and wrap row values in quotes for CSV format
  const escapedRows = rows.map(row =>
    row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
  );

  // Add BOM (Byte Order Mark) \uFEFF for UTF-8 so Excel recognizes Arabic text correctly
  const csvContent = '\uFEFF' + [
    escapedHeaders.join(','),
    ...escapedRows
  ].join('\n');

  // Create blob with UTF-8 encoding
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create download link and trigger download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  
  // Clean up
  URL.revokeObjectURL(link.href);
};

/**
 * Quick export function for simple data
 * @param {string} filename - Download filename
 * @param {array} data - Array of objects to export
 * @param {array} columns - Column names to export (optional, uses object keys if not provided)
 */
export const quickExportCSV = (filename, data = [], columns = null) => {
  if (!Array.isArray(data) || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Get columns from first object if not specified
  const headers = columns || Object.keys(data[0]);
  
  // Extract values in column order
  const rows = data.map(item =>
    headers.map(col => {
      const value = item[col];
      // Handle nested objects and arrays
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      return value ?? '';
    })
  );

  exportToCSV(filename, headers, rows);
};
